"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var TagSolid = function (props) {
    return ((0, jsx_runtime_1.jsx)(Icon_1.default, tslib_1.__assign({}, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M91.8579 24C94.51 24 97.0536 25.0536 98.9289 26.9289L165.429 93.4289C169.334 97.3342 169.334 103.666 165.429 107.571L107.571 165.429C103.666 169.334 97.3342 169.334 93.4289 165.429L26.9289 98.9289C25.0536 97.0536 24 94.51 24 91.8579V34C24 28.4772 28.4772 24 34 24H91.8579ZM58 68C63.5228 68 68 63.5228 68 58C68 52.4772 63.5228 48 58 48C52.4772 48 48 52.4772 48 58C48 63.5228 52.4772 68 58 68Z' }) })));
};
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = TagSolid;
